export enum PitchListsRoutes {
  AddPitches = 'add-pitches',
  CopyMany = 'copy-many',
  CopyOne = 'copy-one',
  Create = 'create',
  DeleteMany = 'delete-many',
  GetCards = 'get-cards',
  GetHashSummaries = 'get-hash-summaries',
  GetOne = 'get-one',
  GetLiveReferences = 'get-live-references',
  GetVisible = 'get-visible',
  ImportCsv = 'import-csv',
  RenameFolder = 'rename-folder',
  Restore = 'restore',
  UpdateCardAvatar = 'update-card-avatar',
  UpdateMany = 'update-many',
  UpdateOne = 'update-one',
}
